import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { MembershipStatus } from 'api/types/memberships/membership';

const STATUS_MAP = {
  upcoming: {
    label: 'upcoming',
    style: 'bg-[#EBF9FD] text-[#2798B3] border-[#2798B3]'
  },
  active: {
    label: 'active',
    style: 'bg-[#E6F4E6] text-[#179713] border-[#179713]'
  },
  suspended: {
    label: 'suspended',
    style: 'bg-[#F5E9E8] text-[#A4332A] border-[#A4332A]'
  },
  expired: {
    label: 'expired',
    style: 'bg-[#F5E9E8] text-[#A4332A] border-[#A4332A]'
  },
  cancelled: {
    label: 'cancelled',
    style: 'bg-[#FCF6EA] text-[#AE8025] border-[#AE8025]'
  }
};

function MembershipStatusTag({ status }: { status: MembershipStatus }) {
  const { t } = useTranslation(['users']);
  const statusData = STATUS_MAP[status];

  if (!status) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      <div
        className={classNames(
          'border-1 rounded-xl flex items-center justify-center px-2 py-2 font-bold text-base',
          statusData.style
        )}
      >
        {t(`users:memberships.status.${statusData.label}`)}
      </div>
    </div>
  );
}

export default MembershipStatusTag;
